import * as React from 'react'
import { Text, StackChildren, Stack, Colors } from '@doordash/design-language'
import Button from '@doordash/component-button'
import { LandingPage as Tag } from '../../../../../models/selectorAnchors'
import t from './strings'
import { InputContainer } from './styles'

type SlideProps = {
  title?: string[]
  subtitle?: string
  legalText?: string
  buttonProps?: typeof Button
}

const Slide: React.FC<SlideProps> = ({
  title,
  subtitle,
  legalText,
  buttonProps,
  children,
}) => {
  const defaultTitle = [t.title1of3(), t.title2of3(), t.title3of3()]
  const defaultSubtitle = t.subtitle()

  const slideTitle = title || defaultTitle
  const slideSubtitle = subtitle || defaultSubtitle

  // the * 2 is a hack until we get a DLS compliant design
  return (
    <React.Fragment>
      <StackChildren size={StackChildren.Sizes.None}>
        {slideTitle.map(slideTitleText => (
          <Text
            display={Text.DisplayModes.Block}
            size={Text.Sizes.S40 * 2}
            styles={Text.Styles.MajorPageTitle}
            lineHeight={Text.LineHeights.S40}
          >
            {slideTitleText}
          </Text>
        ))}
      </StackChildren>
      <Stack size={Stack.Sizes.Medium}>
        <Text styles={Text.Styles.Medium18} color={Colors.SystemGrey60}>
          {slideSubtitle}
        </Text>
      </Stack>
      <InputContainer size={StackChildren.Sizes.Medium}>
        {children}
        {buttonProps && (
          <Button
            size={Button.Sizes.Medium}
            state={buttonProps.state}
            onClick={buttonProps.onClick}
            type={Button.Types.PrimaryPill}
            data-anchor-id={Tag.PrimaryAction}
          >
            {t.signUp()}
          </Button>
        )}
        <Text styles={Text.Styles.Medium12} color={Colors.SystemGrey80}>
          {legalText}
        </Text>
      </InputContainer>
    </React.Fragment>
  )
}

export default Slide
